import React from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import SortableHeader from "../../../../components/atoms/SortableHeader";
import { sortStr, sortNum } from "../../../../common/helpers/helpers";

const sortByStart = (a, b) => sortNum(a.start, b.start);
const sortByEnd = (a, b) => sortNum(a.end, b.end);

const sortByPredictedProteinEffect = (a, b) =>
  sortStr(a.predicted_protein_effect, b.predicted_protein_effect);
const sortByPubmedTotalNumber = (a, b) =>
  sortNum(a.pub_med_references?.length, b.pub_med_references?.length);

const labels = {
  start: "Start",
  end: "End",
  pub_med_references: "Articles",
  predicted_protein_effect: "loss of function",
};

const JaxCkbGeneCurationTable = ({
  items,
  sortedField,
  isAsc,
  toggleField,
}) => {
  if (!items || !items.length) return null;
  return (
    <>
      <table className="varsome-table varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(sortByStart, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="start"
              width="20%"
              align="left"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByEnd, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="end"
              width="20%"
              align="left"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByPubmedTotalNumber, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="pub_med_references"
              width="20%"
              align="left"
            />
            <SortableHeader
              sort={(key) => toggleField(sortByPredictedProteinEffect, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="predicted_protein_effect"
              width="40%"
              align="left"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((item, i) => (
            <tr
              key={`${item?.start}-${item?.eend}-${item?.predicted_protein_effect}-${i}`}
            >
              <td>{item.start || "-"}</td>
              <td>{item.end || "-"}</td>
              <td>
                {item?.pub_med_references?.length ? (
                  <PublicationLinks ids={item.pub_med_references} />
                ) : (
                  "-"
                )}
              </td>
              <td>{item?.predicted_protein_effect || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

JaxCkbGeneCurationTable.propTypes = {
  labels: PropTypes.shape({
    pubMedReferences: PropTypes.string,
    date: PropTypes.string,
    pValue: PropTypes.string,
    diseaseOrTrait: PropTypes.string,
    strongestSnpRiskAllele: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      amp_tier: PropTypes.string,
      approval_status: PropTypes.string,
      cap_asco_evidence_level: PropTypes.string,
      efficacy_evidence: PropTypes.string,
      evidence_type: PropTypes.string,
      indication: PropTypes.string,
      normalized_cancer: PropTypes.string,
      normalized_drug: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
      response_type: PropTypes.string,
      therapy: PropTypes.string,
      therapy_id: PropTypes.number,
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
};

JaxCkbGeneCurationTable.defaultProps = {
  labels: {},
  items: [],
  sortedField: null,
  isAsc: true,
};

export default JaxCkbGeneCurationTable;
